// WCAG 2.x contrast for #rgb / #rrggbb colours. Pure: the office charts and
// the Sales app's brand colours both use it.
export function hexToRgb(hex: string): [number, number, number] | null {
  const m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const h = m[1].length === 3 ? m[1].split('').map((c) => c + c).join('') : m[1];
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16)) as [number, number, number];
}

export function luminance(hex: string): number {
  const rgb = hexToRgb(hex);
  if (!rgb) return 0;
  const [r, g, b] = rgb.map((v) => { const c = v / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrast(a: string, b: string): number {
  if (!hexToRgb(a) || !hexToRgb(b)) return 1;
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
}

// t is b's share, clamped to 0..1 (not a number counts as 0), and every
// channel to 0..255, so the result is always a #rrggbb colour.
export function mixHex(a: string, b: string, t: number): string {
  const x = hexToRgb(a) ?? [0, 0, 0];
  const y = hexToRgb(b) ?? [0, 0, 0];
  const k = Number.isFinite(t) ? Math.min(1, Math.max(0, t)) : 0;
  const channel = (v: number) => Math.min(255, Math.max(0, Math.round(v)));
  return `#${x.map((v, i) => channel(v * (1 - k) + y[i] * k).toString(16).padStart(2, '0')).join('')}`;
}

export function readableInk(bg: string, light = '#ffffff', dark = '#0e0d0b'): { ink: string; ratio: number } {
  if (!hexToRgb(bg)) return { ink: light, ratio: 0 };
  const l = contrast(light, bg);
  const d = contrast(dark, bg);
  return l >= d ? { ink: light, ratio: l } : { ink: dark, ratio: d };
}
